export { createNavigation, type NavItemType } from './navigationSchema';
